const safeLogs = {
  addGlobalContext: () => { },
  debug: () => { },
  warn: () => { },
  info: () => { },
  error: () => { }
};

window._guLogger = window._guLogger || safeLogs;

const Logger = window._guLogger;
export default Logger;